import React from 'react'
import PropTypes from 'prop-types'

const UNAVAILABLE = 'Unavailable'
const AVAILABLE = 'Available'
const BLOCKED = 'Blocked'

function ResultsTable({ items, selectDomain, isNewRegistry, contactLink }) {
  if (items && items.length === 0) return false

  const getDomainState = (item, isNewRegistry) => {
    let state

    if (isNewRegistry) {
      if (item?.statuses.includes('REGISTERED')) {
        state = UNAVAILABLE
      } else if (item?.statuses.includes('BLOCKED') || item?.statuses.includes('BLOCKED_OVERRIDE')) {
        state = BLOCKED
      } else {
        state = AVAILABLE
      }
    } else {
      state = item?.status !== AVAILABLE ? UNAVAILABLE : item?.status
    }
    return state
  }

  const getDomainName = (item, isNewRegistry) => {
    if (isNewRegistry) {
      return item?.domainName ?? ''
    } else {
      return item?.domain.substring(item?.domain.indexOf('.')) ?? ''
    }
  }

  return (
    <ul className='c-available-domain'>
      {items.map((item) => {
        const domainName = getDomainName(item, isNewRegistry)
        const state = getDomainState(item, isNewRegistry)
        const isAvailable = state == AVAILABLE
        const suffix = domainName.substring(domainName.indexOf('.'));

        return (
          <li
            key={`row-${domainName}`}
            className={`c-available-domain__result ${isAvailable ? 'c-available-domain__result--available' : ''}`}
          >
            {isAvailable ? (
              <img className='c-available-domain__tick' src='images/jumpstarter/icons/tick.svg' alt="" aria-hidden />
            ) : (
              <img className='c-available-domain__tick' src='images/jumpstarter/icons/cross.svg' alt="" aria-hidden />
            )}
            <div className='c-available-domain__result-content'>
              <span className='c-available-domain__result-domain'>{domainName}</span>
              <span className='c-available-domain__result-status'>{isAvailable ? 'Available' : 'Not available'}</span>
            </div>
            {contactLink && state === BLOCKED && (
              <a
                href={contactLink}
                className='c-btn c-available-domain__btn'
                data-gtm-referral={domainName}
                aria-label={`Contact us about blocked domain ` + domainName}
              >
                Contact us
              </a>
            )}
            {selectDomain && state !== BLOCKED && (
              <button
                className={`c-btn c-available-domain__btn ${!isAvailable ? 'c-btn--disabled' : ''}`}
                onClick={() => selectDomain(suffix)}
                disabled={!isAvailable && true}
              >
                Select
                <span className='_sr-only'>{domainName}</span>
              </button>
            )}
          </li>
        )
      })}
    </ul>
  )
}

ResultsTable.propTypes = {
  items: PropTypes.array,
  selectDomain: PropTypes.func,
  isNewRegistry: PropTypes.bool,
  contactLink: PropTypes.string,
}

export default ResultsTable
